import { render, staticRenderFns } from "./WatchTheScienceExileFilm.vue?vue&type=template&id=07ca5c25&scoped=true&"
import script from "./WatchTheScienceExileFilm.vue?vue&type=script&lang=js&"
export * from "./WatchTheScienceExileFilm.vue?vue&type=script&lang=js&"
import style0 from "./WatchTheScienceExileFilm.vue?vue&type=style&index=0&id=07ca5c25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ca5c25",
  null
  
)

export default component.exports